import styled from 'styled-components';

export const HotelDescriptionSection = styled.section`
  margin-bottom: 35px;
  
  @media(min-width: 1024px) {
    margin-bottom: 40px;
  }
`;

export const HotelDescriptionContainer = styled.div`
  @media(min-width: 768px) {
    padding-right: 15px;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const HotelTab = styled.article`
  @media(min-width: 1024px) {
    display: flex;
  }
`;

export const HotelContent = styled.div`
  @media(min-width: 1024px) {
    margin-top: -5px;
  }
`;

export const HotelImage = styled.div`
  display: block;
  height: 150px;
  margin-bottom: 45px;
  
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    
    object-fit: cover;
  }
  
  @media(min-width: 768px) {
    width: 345px;
    height: 240px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
    margin-right: 55px;
  }
`;

export const HotelHeading = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    margin-bottom: 40px;
    
    font-size: 24px;
  }
`;

export const HotelDetailedDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-family: inherit !important;
  font-size: 12px;
  line-height: 16px;
  color: inherit !important;
  
  li {
    position: relative;
    
    padding-left: 18px;
    
    &:not(:last-child) {
      margin-bottom: 5px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      border-radius: 50%;
      background-color: #a8a8a8;
    }
  }
  
  * {
    font-family: inherit !important;
    font-size: 12px !important;
    line-height: 16px !important;
    color: inherit !important;
  }
  
  @media(min-width: 768px) {
    font-size: 16px;
    line-height: 18px;
  
    * {
      font-size: 16px !important;
      line-height: 18px !important;
    }
  }
`;
